export const RegexConstants = {
  ALPHA_NUMERIC_REGEX_SPECIAL_CHAR: /^(?=.*[a-zA-Z])[a-zA-Z0-9 !@#$%^&*()_+={}\[\]:;"'<>,.?/~`|-]*$/,
  ALPHA_NUMERIC_REGEX: "^[a-zA-Z0-9 '-]+$",
  CIN_REGEX: '^[a-zA-Z0-9]+$',
  PASSPORT_REGEX: '^[a-zA-Z0-9]+$',
  ONLY_LETTERS_REGEX: "^[a-zA-Z '-]+$",
  ONLY_NUMBERS_REGEX: '^[0-9]*$',
  nameRegularExpression: "^[a-zA-Z]+(([',. -][a-zA-Z ])?[a-zA-Z]*)*$",
  LETTERS_AND_SPACES: /^[a-zA-Z\s]+$/,
  ALPHANUMERIC_AND_SPACES: /^[a-zA-Z0-9\s]+$/,
  ALPHANUMERIC_SPACES_HYPHEN: /^[a-zA-Z0-9\s\-]+$/,
  ALPHANUMERIC_PLUS_MINUS: /^[a-zA-Z0-9\s+\-]+$/,
  mailRegularExpression: '[A-Za-z0-9._%-]+@[A-Za-z0-9._%-]+\\.[a-z]{2,3}',
  DECIMAL_NUMBER_REGEX: '^[0-9]+(\\.[0-9]{1,2})?$',
  phoneRegularExpression: /^(06|07)\d{8}$|^\+212[67]\d{8}$/,
  PARAGRAPH_REGEX: '^.*(\r?\n.*)*$',
  ALPHA_NUMERIC_REGEX_SPECIAL_CHAR_ONE_LETTER: /^(?=.*[a-zA-Z])[a-zA-Z0-9 ]*$/,
  ALPHA_NUMERIC_REGEX_1: /^[.]*[A-Za-z0-9]+[a-zA-Z0-9 -]*$/,
  arabicRegex: /^[\u0600-\u06FF]+([\s'\-][\u0600-\u06FF]+)*$/,
  PHONE_NUMBER_REGEX: /^\(212\) \d{3}-\d{6}$/,
  dateFormat: /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}\+\d{2}:\d{2}$/,
  PROJECT_NAME: /^[\p{L}\p{N}()._\-\s&]+$/u,
  START_WITH_LETTER: /^[\p{L}\p{N}_]/u,
  SALARY_PATTERN: /^\d+(\.\d{1,2})?$/,
  CLIENT_NAME_ALLOWED_CHARS: /^[\p{L}\p{N}()\-_.&\s]+$/u,
  CLIENT_NAME_CHARS_ORDER: /^[\p{L}\p{N}_].*$/u,
  COUNTRY_NAME: /^[A-Za-z\s'-]{3,}$/,
  COUNTRY_NAME_ES: /^[A-Za-zÁÉÍÓÚáéíóúÜüÑñ\s'-]{3,}$/,
  COUNTRY_NAME_AR: /^[ء-ي\s'-]{3,}$/,
  REGION_NAME: /^[A-Za-z\s'-]{3,}$/,
  REGION_NAME_ES: /^[A-Za-zÁÉÍÓÚáéíóúÜüÑñ\s'-]{3,}$/,
  REGION_NAME_AR:/^[ء-ي\s'-]{3,}$/,
  STATUS_NAME: /^[A-Za-z\s'-]{3,}$/,
  STATUS_NAME_ES: /^[A-Za-zÁÉÍÓÚáéíóúÜüÑñ\s'-]{3,}$/,
  STATUS_NAME_AR:/^[ء-ي\s'-]{3,}$/,
  /** IBBIOL / invoicing project account pre-project code (e.g. ABC-123456-12345). */
  PROJECT_ACCOUNT_IBBIOL_PATTERN: /^[A-Z]{3}-[0-9]{6}-[0-9]{5}$/,
  COUNTRY_REGION_CODE: /^[A-Z]{2}$/,
  latinRegex :/^[a-zA-Z\s'\-À-ÖØ-öø-ÿ]*$/,
 ADDRESS_REGEX: /^(?=.{3,255}$)[^<>{}\[\]\\\"^$=`|_]+$/,
 Medical_Visit_REGEX: /^[\p{L}\p{N}\s.,;:!?'"()\[\]{}_\-+=@#$%^&*\/~`<>]*$/u,
 SECTORS_NAME: /^[A-Za-z\s'-]{3,}$/,
  SECTORS_NAME_ES: /^[A-Za-zÁÉÍÓÚáéíóúÜüÑñ\s'-]{3,}$/,
  SECTORS_NAME_AR:/^[ء-ي\s'-]{3,}$/,
  NEARSHORE_NAME: /^[A-Za-z\s'-]{3,}$/,
  NEARSHORE_NAME_ES: /^[A-Za-zÁÉÍÓÚáéíóúÜüÑñ\s'-]{3,}$/,
  NEARSHORE_NAME_AR:/^[ء-ي\s'-]{3,}$/,
 CLUSTER_NAME: /^[A-Za-z\s'-]{3,}$/,
 CLUSTER_NAME_ES: /^[A-Za-zÁÉÍÓÚáéíóúÜüÑñ\s'-]{3,}$/,
  CLUSTER_NAME_AR:/^[ء-ي\s'-]{3,}$/,
  OFFSHORE_DENOMINATION_EN: /^[A-Za-z\s'-]+$/,
  OFFSHORE_DENOMINATION_ES: /^[A-Za-zÁÉÍÓÚáéíóúÜüÑñ\s'-]+$/,
  OFFSHORE_DENOMINATION_AR:/^[ء-ي\s'-]{3,}$/,
  JIRA_PROJECT_KEY: /^[A-Za-z][A-Za-z0-9]*$/,

};
